export var cisChevronLeftAlt = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='313.373 462.627 106.745 256 313.373 49.373 358.627 94.627 197.255 256 358.627 417.373 313.373 462.627' class='ci-primary'/>"];
